import { useEffect, useRef, useState } from 'react'
import { logger } from 'shared/lib'
import { type IEnhancePromptProps } from 'entities/AIAgent/actions/enhancePrompt/EnhancePrompt'

export const useEnhanceRequest = ({
  requestEnhance,
  setError,
  prompt,
}: {
  prompt: IEnhancePromptProps['prompt']
  requestEnhance: IEnhancePromptProps['requestEnhance']
  setError: IEnhancePromptProps['setError']
}) => {
  const refAbortController = useRef<AbortController | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const enhance = async () => {
    if (!prompt.trim()) {
      setError('Add instructions for your Agent')
      return
    }
    try {
      setLoading(true)
      const abortController = new AbortController()
      refAbortController.current = abortController
      return await requestEnhance(prompt, abortController.signal)
    } catch (e) {
      logger.error(e)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    return () => {
      refAbortController.current?.abort()
    }
  }, [])

  return { enhance, loading }
}
